import React from 'react';

const LiveTextWidgetHeader = ({ title }) => {
    if (!title) return null;

    return (
        <div className="live-text-widget-header__header">
            <h3
                className="live-text-widget-header__headline"
            >{title}</h3>
        </div>
    );
};

export default LiveTextWidgetHeader;
